import { Request } from '@/core'
import { reports } from '@/constants/urls'

export default {
  getManagerExcelReport: params =>
    Request.post(reports.managerExcelReport, params),
}
